<template>
    <div class="talent_acquisition" v-loading="loading">
        <div class="talent_acquisition1">
            <div class="talent_acquisition_box1">
                <div class="title_box">
                    <img src="@/assets/img/login/Frame.png" alt="">
                    <span class="span1">首页</span> > <span class="span2">人才招聘</span>
                </div>
                <div class="title_box2">
                    <div class="title_borders"></div>
                    <div class="title_texts">岗位招聘</div>
                </div>
                <div class="list_item">
                    <div class="item" v-for="(item,index) in list" :key="index" @click="handle_detial(item)">
                        <div class="item_left">
                            <div class="item_titles">{{ item.title }}</div>
                            <div class="tege_felx">
                                <div class="tages">
                                    {{minx_get_province(item.province)}}，中国
                                </div>
                                <div class="borders"></div>
                                <div class="tages">
                                    {{ item.job_type==1?'法律实习生':'' }}
                                    {{ item.job_type==2?'法律律师':'' }}
                                    {{ item.job_type==3?'企业法务':'' }}
                                </div>
                                <div class="borders"></div>
                                <div class="tages">
                                    <!-- 2020年12月20日 -->
                                     {{ item.pub_time }}
                                </div>
                            </div>
                            <div class="item_const">
                                {{ item.desc }}
                            </div>
                        </div>
                        <div class="item_right" >
                            <div class="btns">
                                <img src="../../../assets/img/index/talent_acquisition/rights.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pages_box">
                        <div class="btns" @click="handle_pages(1)">首页</div>
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pages.page"
                            background
                            :page-size="pages.limit"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                        <div class="btns"  @click="handle_pages(last_page)">尾页</div>
                    </div>
            </div>
        </div>
        

    </div>
</template>
<script>
import { useListeners } from 'vue';
import {
    mapState
} from 'vuex'



export default { 
    components: {

    },
    name: "homes",
    data() {
        return {
            loading: false,
            total: 0,
            pages: {
                page: 1,
                limit: 10,
                recommend:0,
            },
            list:[],
            last_page:1,
        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        this.get_list()
    },
    methods: {
        handleSizeChange(e) {
            console.log('条数', e)
            this.pages.page = 1
            this.pages.limit = e
            this.get_list()
        },
        handleCurrentChange(e) {
            console.log('页数', e)
            this.pages.page = e
            this.get_list()
        },
        handle_pages(i) {
            console.log('首页尾页', i)
            this.pages.page = i
            this.get_list()
        },
        get_list(){
            this.loading=true
            this.$api("jobList", {
                ...this.pages,
                // limit:20,
                // recommend:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('职位列表',res)
                if (res.code == 1) {
                    this.list=res.data.data
                    this.last_page=res.data.last_page
                    this.total=res.data.total
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_detial(item){
            this.$router.push({
                path:'/talent_acquisition_detial',
                query:{
                    id:item.id
                }
                
            })
        },
      
    },

}
</script>
<style scoped lang="less">
.talent_acquisition {
    width: 100%;

    .talent_acquisition1 {
        background-color: #F5F5F5;
        padding-bottom: 50px;

        .talent_acquisition_box1 {

            width: 1440px;
            margin: auto;
            padding-top: 20px;
            padding-bottom: 40px;

            .title_box {
                padding-bottom: 21px;

                display: flex;
                align-items: center;

                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #999999;

                .span1 {
                    cursor: pointer;
                    margin-right: 10px;
                }

                .span2 {
                    cursor: pointer;
                    margin-left: 10px;
                }

                img {
                    margin-right: 10px;
                }
            }
            .title_box2{
                display: flex;
                align-items: center;
                .title_borders{
                    width: 4px;
                    height: 40px;
                    background: #377CFD;
                    border-radius: 3px 3px 3px 3px;
                }
                .title_texts{
                    padding-left: 20px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 36px;
                    color: #333333;
                }
            }
            .list_item{
                padding-top: 40px;
                .item{
                    width: 1440px;
                    height: 240px;
                    background: #FFFFFF;
                    box-shadow: 0px 0px 18px 1px rgba(0,0,0,0.08);
                    margin-bottom:24px ;
                    padding: 48px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    cursor: pointer;
                    .item_left{
                        width: 1000px;
                        .item_titles{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 24px;
                            color: #333333;
                        }
                        .tege_felx{
                            display: flex;
                            align-items: center;
                            margin-top: 16px;
                            .tages{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 16px;
                                color: #666666;
                            }
                            .borders{
                                width: 1px;
                                height: 16px;
                                background: #000000;
                                border-radius: 0px 0px 0px 0px;
                                opacity: 0.18;
                                margin: 0 20px;
                            }
                        }
                        .item_const{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 16px;
                            color: #666666;
                            padding-top: 24px;
                        }
                    }
                    .item_right{
                        .btns{
                            width: 64px;
                            height: 64px;
                            background: #FFFFFF;
                            border: 1px solid #E5E5E5;
                            border-radius: 50%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            cursor: pointer;
                            img{
                                width: 14px;
                            }
                        }
                    }
                }
            }
            .pages_box{
                width: 100%;
                height: 100px;
                // background-color: red;
                display: flex;
                align-items: center;
                justify-content: center;
                /deep/.el-pagination{
                    .el-pager{
                        .number {
                            background-color: #FFFFFF;
                        }
                        .active{
                            background-color: #377CFD;
                        }
                    }
                }
                .btns{
                    width: 40px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #EEEEEE;  
                    font-family: PingFang-SC-Medium, PingFang-SC-Medium;
                    font-weight: normal;
                    font-size: 14px;
                    color: #7A7A7A;
                    text-align: center;
                    line-height: 32px;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>